"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var dom_1 = require("../utils/dom");
var misc_1 = require("../utils/misc");
var misc_2 = require("./misc");
/**
 * Create an Obvservable that enables rotating an HTML element
 * and emits a stream of updated rotation.
 *
 * @param element HTML Element for which to enable rotation.
 * @param handle HTML Element of the movable handle
 */
exports.createRotateObservable = function (_a) {
    var element = _a.element, handle = _a.handle, onComplete = _a.onComplete;
    var mouseDown$ = rxjs_1.fromEvent(handle, 'mousedown');
    return mouseDown$.pipe(operators_1.filter(function (e) { return e.which === 1; }), // left clicks only
    operators_1.switchMap(function (e) {
        e.preventDefault();
        e.stopPropagation();
        // Use the center of the Element as a rotation point
        var position = element.getBoundingClientRect();
        var axisX = (element.offsetWidth + position.left * 2) / 2;
        var axisY = (element.offsetHeight + position.top * 2) / 2;
        // Create a function that calculates the angle of a
        // line starting at the center of the Element
        var angleFromAxis = misc_1.angleBetweenPoints(axisX, axisY);
        var currentRotation = dom_1.rotationOfElement(element);
        var initialAngle = angleFromAxis(e.clientX, e.clientY) - currentRotation;
        var rotate$ = misc_2.documentMouseMove$.pipe(operators_1.map(translateRotation(angleFromAxis, initialAngle)));
        return misc_2.requestAnimationFramesUntil(rotate$, misc_2.documentMouseUp$, onComplete);
    }));
};
/**
 * Calculate the final rotation based on the mouse's angle from
 * the center axis and original rotation of the html element.
 */
var translateRotation = function (angleCalculator, initialAngle) { return function (e) {
    var interval = e.shiftKey ? 15 : 0.1;
    var angle = misc_1.round(angleCalculator(e.clientX, e.clientY) - initialAngle, interval);
    return {
        rotation: angle + "deg",
    };
}; };
//# sourceMappingURL=rotate.js.map